import { useEffect, useState } from 'react'

const STORAGE_KEY = 'offer-deadline-45dias'
const DURATION_MS = 24 * 60 * 60 * 1000

type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

export function useOfferCountdown(): Countdown {
  const [remaining, setRemaining] = useState<number>(() => getRemaining())

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000)
    return () => window.clearInterval(id)
  }, [])

  const totalSeconds = Math.max(0, Math.floor(remaining / 1000))
  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}

function getDeadline(): number {
  const now = Date.now()
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY))
    if (stored && stored > now) return stored
    const next = now + DURATION_MS
    window.localStorage.setItem(STORAGE_KEY, String(next))
    return next
  } catch {
    return now + DURATION_MS
  }
}

function getRemaining(): number {
  return getDeadline() - Date.now()
}

function pad(value: number): string {
  return String(value).padStart(2, '0')
}
